export enum SocialAuthProviders {
    GOOGLE = 'google',
    FACEBOOK = 'facebook'
}